import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";

// Personality: Night sky, restful — dusk gradient, moon, hushed type.
const SleepLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[hsl(230,35%,15%)] via-[hsl(250,25%,25%)] to-[hsl(30,30%,92%)] text-[hsl(30,25%,95%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-16 pb-32 text-center max-w-3xl">
        <img src="/sleep-quality-icon.png" alt="" className="w-24 h-24 mx-auto mb-8 opacity-90" />
        <span className="text-xs uppercase tracking-[0.4em] text-white/60">Sleep Tracker</span>
        <h1 className="mt-6 text-5xl md:text-7xl leading-[1.05]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
          The nights are different now. Let's understand why.
        </h1>
        <p className="mt-8 text-lg text-white/75 leading-relaxed">
          Hormonal shifts change sleep in ways nobody warned you about. Track disruption causes,
          spot what wakes you, and find the changes that give the night back to you.
        </p>
        <Button asChild size="lg" className="mt-10 px-10 py-6 text-lg bg-white text-[hsl(230,35%,15%)] hover:bg-white/90">
          <Link to="/sleep-tracker"><Moon className="mr-2 h-5 w-5" /> Track tonight <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <section className="container mx-auto px-6 pb-24 grid md:grid-cols-3 gap-8 text-foreground">
        {[
          { t: "Disruption causes", d: "Night sweats, racing thoughts, bladder, pain — logged in seconds." },
          { t: "Insight over data", d: "Aura only speaks when there's enough for a real pattern." },
          { t: "Doctor-ready", d: "Weeks of nights, summarised into one clear picture." },
        ].map((f) => (
          <div key={f.t} className="bg-background/95 rounded-2xl p-8 border border-white/10">
            <h3 className="text-2xl mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{f.t}</h3>
            <p className="text-foreground/70 leading-relaxed">{f.d}</p>
          </div>
        ))}
      </section>

      <div className="bg-background text-foreground"><Footer /></div>
    </div>
  );
};
export default SleepLanding;
